// extracted by mini-css-extract-plugin
export default {"container":"radio-redesigned_container__demsr","button":"radio-redesigned_button__5kXza","radio":"radio-redesigned_radio__4Vju9","label":"radio-redesigned_label__2NjbV"};